'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _Icon = require('../../../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Notice = require('../Notice');

var _Notice2 = _interopRequireDefault(_Notice);

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _Translate = require('../../../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

var _Alert = require('../../../../components/Alert');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashierResult = function CashierResult(_ref) {
  var status = _ref.status,
      generalError = _ref.generalError,
      providerType = _ref.providerType,
      cashierType = _ref.cashierType,
      currency = _ref.currency,
      wallet = _ref.wallet,
      handleClose = _ref.handleClose,
      handleTryAgain = _ref.handleTryAgain,
      successMessage = _ref.successMessage;

  if (wallet && wallet.isLoading) return null;

  if (status === 'success' || status === 'pending') {
    var intl = (0, _reactIntl.useIntl)();

    var messageKey = 'message.' + (cashierType ? 'deposit' : 'withdrawal') + '.' + status;

    if (providerType && intl.messages[messageKey + '.' + providerType]) {
      messageKey = messageKey + '.' + providerType;
    }

    return _react2.default.createElement(
      'div',
      { className: 'cashier-accordion' },
      _react2.default.createElement(
        'div',
        { className: 'payment-result-wrapper' },
        _react2.default.createElement(_Notice2.default, {
          level: 'success',
          icon: _react2.default.createElement(_Icon2.default, { icon: 'check' }),
          header: _react2.default.createElement(_Translate2.default, { id: messageKey })
        }),
        successMessage && _react2.default.createElement(
          'div',
          { className: 'payment-result-success-message' },
          _react2.default.createElement(_Notice2.default, {
            level: 'warning',
            icon: _react2.default.createElement(_Icon2.default, { icon: 'info' }),
            content: _react2.default.createElement('div', {
              dangerouslySetInnerHTML: { __html: (0, _marked2.default)(successMessage) }
            })
          })
        ),
        cashierType === 'deposit' && _react2.default.createElement(
          'div',
          { className: 'payment-result-content' },
          _react2.default.createElement(
            'div',
            { className: 'payment-result-new-balance' },
            _react2.default.createElement(_Translate2.default, {
              id: 'message.cashier.new-balance',
              defaultMessage: 'Your new balance is:'
            })
          ),
          wallet.data && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'payment-result-balance' },
              _react2.default.createElement(_reactIntl.FormattedNumber, {
                value: wallet.data.Total.Balance,
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            ),
            wallet.data.Bonus.Balance > 0 && _react2.default.createElement(
              'div',
              { className: 'payment-result-bonus' },
              _react2.default.createElement(_Translate2.default, {
                id: 'message.cashier.balance-bonus',
                defaultMessage: '(Of which {amount} is bonus money)',
                values: {
                  amount: _react2.default.createElement(_reactIntl.FormattedNumber, {
                    value: wallet.data.Bonus.Balance,
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'button primary',
            type: 'button',
            onClick: handleClose },
          _react2.default.createElement(_Translate2.default, { id: 'action.button.continue', defaultMessage: 'Continue' })
        )
      )
    );
  }

  if (status === 'error') {
    return _react2.default.createElement(
      'div',
      { className: 'cashier-accordion' },
      _react2.default.createElement(
        'div',
        { className: 'payment-result-wrapper' },
        _react2.default.createElement(_Notice2.default, {
          icon: _react2.default.createElement(_Icon2.default, { icon: 'stop-circle' }),
          header: _react2.default.createElement(_Translate2.default, { id: 'message.cashier.error', defaultMessage: 'Error' }),
          content: generalError ? _react2.default.createElement(_Translate2.default, {
            id: 'message.' + (cashierType ? 'deposit' : 'withdrawal') + '.error',
            defaultMessage: (cashierType ? 'Deposit' : 'Withdraw') + ' error.'
          }) : _react2.default.createElement(_Translate2.default, {
            id: 'message.' + (cashierType ? 'deposit' : 'withdrawal') + '.canceled',
            defaultMessage: (cashierType ? 'Deposit' : 'Withdraw') + ' canceled.'
          })
        }),
        !generalError && _react2.default.createElement(
          'div',
          { className: 'payment-result-content' },
          _react2.default.createElement(_Translate2.default, {
            id: 'message.' + (cashierType ? 'deposit' : 'withdrawal') + '.failed'
          })
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'button secondary',
            type: 'button',
            onClick: handleTryAgain },
          _react2.default.createElement(_Translate2.default, { id: 'action.try-again', defaultMessage: 'Try again' })
        )
      )
    );
  }

  return null;
};

exports.default = CashierResult;